import { OfferPriceButton } from "./OfferPriceButton.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/offer-pricing/InsuranceOfferPriceButton.tsx
const InsuranceOfferPriceButton = ({ price, planPays, onClick, isSelected }) => {
	const { t } = useTranslation("phx-lib");
	const subtitle = price && planPays ? t("pricing.planPays", { planPays }) : t("pricing.unknown");
	return /* @__PURE__ */ jsx(OfferPriceButton, {
		title: t("pricing.insurancePrice"),
		subtitle,
		isSelected,
		onClick,
		price
	});
};

//#endregion
export { InsuranceOfferPriceButton };